import { CommonData } from "../types/common";

export const getFirstOffer = (data: CommonData): void => {
    if (!data) {
        return;
    }

    const { previousOffer } = data || {};
    if (previousOffer && Array.isArray(previousOffer) && previousOffer.length > 0) {
        data.offer = previousOffer[0];
    }
};

export const getUpdatedAppliedValues = (data: CommonData): void => {
    if (!data) {
        return;
    }

    const { updatedValues } = data.updates || {};
    if (updatedValues) {
        const { application } = data.agentApiApplication;
        if (updatedValues.loanAmount)
            application.appliedAmount = updatedValues.loanAmount;

        if (updatedValues.refinanceAmount)
            application.refinanceAmount = updatedValues.refinanceAmount;
    }
};